module.exports = ".grey_background {\n  background-color: #f0f0f0;\n  padding: 4px;\n  padding-left: 25px;\n  font-size: 12px; }\n"